{
  "lang": "nl",
  "theme": "template-iframe",
  "master": "masters/template-iframe/ru-groningen-demonstratie",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "case-template",
    "close-caseslist",
    "has-no-next",
    "headings",
    "history",
    "info-inline",
    "md-labels",
    "metaprogress",
    "model-filter",
    "modelinfo",
    "modelitem",
    "no-login",
    "reset-password",
    "show-server-side-validation",
    "showdown",
    "showdown-converter"
  ],
  "overrideinloghtml": "demonstratie.html",
  "arbitrary": {
    "jumplisttitle": "Stappen:",
    "headings": {
      "baseLevel": "2"
    }
  },
  "template": {
    "less": {
      "post": [
        "theme.less",
        "sizes.less"
      ]
    },
    "restartbuttontxt": "Herstarten",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "rethink-sans"
  ]
}
